import React, { useState, useEffect, useRef } from 'react';
import { registerUser } from '../../services/permissionsService';
import {
  showErrorToast,
  showSuccessToast,
} from '../../../../utils/toastHelper';
import { useTranslation } from 'react-i18next';
export default function AddPermissionModal({
  permissionsTypes,
  refreshUsers,
  onClose,
  isOpen,
}) {
  const enablePermissionFeature = false;
  const { t } = useTranslation('permissions');
  const { t: tLogin } = useTranslation('login');
  const [permissionsState, setPermissionsState] = useState({});
  const [userData, setUserData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };
  // const closeRef = useRef(null);
  const resetForm = () => {
    setShowPassword(false);
    setUserData({ email: '', password: '' });

    const initialPermissionsState = permissionsTypes.reduce(
      (acc, permissionType) => {
        acc[permissionType.id] = {
          // add: false, // default to false (unchecked)
          view: false, // default to false (unchecked)
          edit: false, // default to false (unchecked)
        };
        return acc;
      },
      {}
    );

    // Set the state with all permissions as false
    setPermissionsState(initialPermissionsState);
  };

  useEffect(() => {
    // Initialize all permissions to false
    const initialPermissionsState = permissionsTypes.reduce(
      (acc, permissionType) => {
        acc[permissionType.id] = {
          // add: false, // default to false (unchecked)
          view: false, // default to false (unchecked)
          edit: false, // default to false (unchecked)
        };
        return acc;
      },
      {}
    );

    // Set the state with all permissions as false
    setPermissionsState(initialPermissionsState);
  }, [permissionsTypes]);
  useEffect(() => {
    if (isOpen) {
      resetForm();
    }
  }, [isOpen]);
  useEffect(() => {
    const modalElement = document.getElementById('permissions-add');
    const modalInstance = new window.bootstrap.Modal(modalElement, {
      backdrop: 'static',
      keyboard: false,
    });

    if (isOpen) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
    return () => {
      modalInstance.hide();
    };
  }, [isOpen]);
  console.log('modal permissionsState ', permissionsState);
  const handleCheckboxChange = (permissionTypeId, permissionType, e) => {
    const checked = e.target.checked;

    setPermissionsState((prevState) => {
      const currentPermissions = prevState[permissionTypeId] || {};
      let updatedPermissions = {
        ...currentPermissions,
        [permissionType]: checked,
      };

      // Rule 1: If "edit" is selected, ensure "view" is also selected
      if (permissionType === 'edit' && checked) {
        updatedPermissions.view = true;
      }

      // Rule 2: If "view" is unselected, unselect "edit" as well
      if (permissionType === 'view' && !checked) {
        updatedPermissions.edit = false;
      }

      return {
        ...prevState,
        [permissionTypeId]: updatedPermissions,
      };
    });
  };
  const handleInputChange = (e) => {
    setUserData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    console.log(userData);
  };

  const handleSelectAll = (permissionType, isChecked) => {
    const updatedState = { ...permissionsState };

    Object.keys(updatedState).forEach((permissionTypeId) => {
      if (permissionType === 'edit') {
        // Selecting/deselecting edit must also affect view
        updatedState[permissionTypeId].edit = isChecked;
        if (isChecked) {
          updatedState[permissionTypeId].view = true; // ensure view is checked if edit is checked
        }
      } else if (permissionType === 'view') {
        updatedState[permissionTypeId].view = isChecked;
        if (!isChecked) {
          updatedState[permissionTypeId].edit = false; // uncheck edit if view is unchecked
        }
      }
    });

    setPermissionsState(updatedState);
  };

  const isSelectAllChecked = (permissionType) => {
    return Object.values(permissionsState).every(
      (permissions) => permissions[permissionType]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (userData?.password?.length < 8) {
      showErrorToast(tLogin('PASSWORDMUSTBEATLEAST8CHARACTERS'));
      setLoading(false);
      return;
    }
    // Prepare data to send, including false values for unchecked permissions
    const permissionDataToSend = Object.keys(permissionsState).map(
      (permissionTypeId) => {
        const permission = permissionsState[permissionTypeId];
        return {
          permission_id: permissionTypeId,
          // add_permission: permission.add ? 1 : 0, // 1 for checked, 0 for unchecked
          view_permission: permission.view ? 1 : 0, // 1 for checked, 0 for unchecked
          edit_permission: permission.edit ? 1 : 0, // 1 for checked, 0 for unchecked
        };
      }
    );
    const dataToSend = {
      ...userData,

      permissions: permissionDataToSend,
    };
    // Send data in POST request
    try {
      console.log('data to send', dataToSend);
      const response = await registerUser(dataToSend);
      if (response.success) {
        console.log(response);
        showSuccessToast(response.message);
        // const modal = new window.bootstrap.Modal(modalRef.current);
        // modal.hide();
        // closeRef.current.click();
        onClose('add');
        await refreshUsers();
      }
    } catch (error) {
      console.error('Error:', error);
    }
    setLoading(false);
  };

  return (
    <div
      className="modal fade"
      id="permissions-add"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {t('ADDPERMISSIONS')}
            </h1>
            <button
              type="button"
              className="btn-close"
              // data-bs-dismiss="modal"
              // aria-label="Close"
              // ref={closeRef}
              onClick={() => {
                onClose('add');
              }}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-sm-6">
                <div className="did-floating-label-content">
                  <input
                    className="did-floating-input"
                    type="email"
                    name="email"
                    placeholder=" "
                    onChange={handleInputChange}
                    value={userData.email}
                  />
                  <label className="did-floating-label">
                    {/* {t('USERNAME')}/ */}
                    {t('EMAIL')} <span className="required">*</span>
                  </label>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="did-floating-label-content">
                  <input
                    className="did-floating-input"
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    placeholder=" "
                    onChange={handleInputChange}
                    value={userData.password}
                    autoComplete="new-password"
                  />
                  <span
                    className="eye-icon-change"
                    onClick={togglePasswordVisibility}
                  >
                    <img
                      src={
                        showPassword
                          ? 'images/eye-black-open.svg'
                          : 'images/eye-black-close.svg'
                      }
                      alt={showPassword ? 'Hide Password' : 'Show Password'}
                    />
                  </span>
                  <label className="did-floating-label">
                    {t('PASSWORD')}
                    <span className="required">*</span>
                  </label>
                </div>
              </div>
            </div>
            {enablePermissionFeature && (
              <div className="table-outer permissions">
                <table className="table">
                  <thead>
                    <tr className="t-heading">
                      <th className="permissions-type">
                        <h5>{t('PERMISSIONSTYPE')}</h5>
                      </th>
                      <th className="permission">
                        <div className="checkbox-container">
                          <ul>
                            <li>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={isSelectAllChecked('view')}
                                  onChange={(e) =>
                                    handleSelectAll('view', e.target.checked)
                                  }
                                />
                                <span className="checkmark"></span>
                                <span className="label-text">{t('VIEW')}</span>
                              </label>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={isSelectAllChecked('edit')}
                                  onChange={(e) =>
                                    handleSelectAll('edit', e.target.checked)
                                  }
                                />
                                <span className="checkmark"></span>
                                <span className="label-text">
                                  {t('CHANGE')}
                                </span>
                              </label>
                            </li>
                          </ul>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {permissionsTypes.map(
                      (permissionType, permissionTypeIndex) => (
                        <tr key={permissionTypeIndex}>
                          <td className="permissions-type">
                            <h5>{t(permissionType.key)}</h5>
                          </td>
                          <td className="permission">
                            <div className="checkbox-container">
                              <ul>
                                <li>
                                  <label className="custom-checkbox">
                                    <input
                                      type="checkbox"
                                      checked={
                                        permissionsState[permissionType.id]
                                          ?.view || false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          permissionType.id,
                                          'view',
                                          e
                                        )
                                      }
                                    />
                                    <span className="checkmark"></span>
                                    <span className="label-text">
                                      {t('VIEW')}
                                    </span>
                                  </label>
                                  <label className="custom-checkbox">
                                    <input
                                      type="checkbox"
                                      checked={
                                        permissionsState[permissionType.id]
                                          ?.edit || false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          permissionType.id,
                                          'edit',
                                          e
                                        )
                                      }
                                    />
                                    <span className="checkmark"></span>
                                    <span className="label-text">
                                      {' '}
                                      {t('CHANGE')}
                                    </span>
                                  </label>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <div className="bottom-button">
              <div className="row">
                <div className="col-sm-6">
                  <button
                    className="cancel"
                    type="button"
                    // data-bs-dismiss="modal"
                    // aria-label="Close"
                    onClick={() => {
                      onClose('add');
                    }}
                  >
                    {t('CANCEL')}
                  </button>
                </div>
                <div className="col-sm-6">
                  <button onClick={handleSubmit} className="save">
                    {loading ? t('LOADING') + '...' : t('ADD')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
